<section class="profile">
    <div class="profile1">
        <div class="search">
            <mat-icon style="padding: 0px 0px 0px 6px;">search</mat-icon>
            <input class="form-control" type="text" name="search" [(ngModel)]="searchText" autocomplete="off"
                placeholder="  Search Keyword">
            <mat-icon>notification</mat-icon>
        </div>
        <div class="profilePic">
            <div class="about">
                <span>Hello,</span>
                <span class="name">{{name}}!</span>
                <!-- <span style="font-weight: 400;
font-size: 13px;
line-height: 24px;
color:grey">copy your bio link and paste it in your profile to let</span> -->
            </div>
            <div class="image">

                <img src="/assets/userDummy.svg">
            </div>
        </div>
        <div class="clipboard">
            <div class="copy"><span class="link">AdminAdmin.in</span>
                <mat-icon style=" transform: rotate(90deg);">remove</mat-icon>
                <mat-icon style="margin-right: 10px;cursor: pointer;color: gray;">file_copy</mat-icon>
            </div>
            <img src="/assets/King.png" style="cursor: pointer;">
        </div>
        <!-- <div class="upgrade"><img src="/assets/Upgrade_to_Pro.png"></div> -->
<div class="reminders">
<div class="Viewall">
    <span class="fontsize">Notification</span>
    <div style="display: flex;cursor: pointer;"><span style="color:  #0088FF;">View All</span><mat-icon style="color:  #0088FF;">chevron_right</mat-icon></div>
</div>
<div class="list">
<div class="list1">
<div class="blockDiv"><mat-icon style="color: red;">error_outline</mat-icon></div>
<div class="listData">
    <span>Blocking Reminder</span>
<span style="font-size: 10px;color: grey;">----Blocking all the Reminders----</span>
</div>
</div>
<div class="list1">
    <div class="blockDiv"style="background-color:#F4A460"><mat-icon style="color: orangered;">message</mat-icon></div>
<div class="listData">
    <span>New Message</span>
<span style="font-size: 10px;color: grey;">---- New Message abcdef ----</span>
</div>
</div>
<div class="list1">
    <div class="blockDiv"><mat-icon style="color: red;">error_outline</mat-icon></div>
<div class="listData">
    <span>New booking</span>
<span style="font-size: 10px;color: grey;">----Blocking all the Reminders----</span>
</div>
</div>
<div class="list1">
    <div class="blockDiv" style="background-color: #F4A460;"><mat-icon style="color: orangered;">message</mat-icon></div>
<div class="listData">
    <span>New Message</span>
<span style="font-size: 10px;color: grey;">----Blocking all the Reminders----</span>
</div>
</div>

</div>

</div>

    </div>
</section>